var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"report_item_section_li"},[_c('keep-alive',[_c(_vm.componentSelectComputed,{tag:"components",attrs:{"patientInfoProps":_vm.patientInfoProps}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }